<template>
  <div class="a">
    <div class="analysis-overview">
      <div class="analysis-head">
        <div class="analysis-head__num">01</div>
        <div class="analysis-head__title">测评概览</div>
      </div>
      <div class="p-select">
        <i class="el-icon-date"></i>
          <el-select popper-class="selectFrom" v-model="value" placeholder="" @change="timeChange">
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.label"
              :value="item.value"
              >
            </el-option>
          </el-select>
      </div>
    </div>
     <div class="analysis-list" v-if="evaluation_num!==0">
        <div class="analysis-item">
          <img src="../../images/test_num.png" alt="">
          <span>布置测评数</span>
          <span class="mr-20">{{evaluation_num}}<span class="fz-24">个</span></span>
        </div>
        <div class="analysis-item">
          <img src="../../images/class_study_day.png" alt="">
          <span>平均完成率</span>
          <span class="mr-20">{{complete_lv}}<span class="fz-24">%</span></span>
        </div>
        <div class="analysis-item">
          <img src="../../images/avg_lv.png" alt="">
          <span>平均正答率</span>
          <span class="mr-20">{{avg_accuary}}<span class="fz-24">%</span></span>
        </div>
     </div>
     <div style="margin-bottom:60px" v-else>
        <Empty content="暂无测评数据~" />
     </div>
    <test-line :accuaryTrend="accuaryTrend"
      :startDate="start_date"
     :classId="classId" v-if="accuaryTrend.length>0"/>
    <!-- 测评学业分析 -->
    <academic-analysis :classId="classId" />
  </div>
</template>

<script>
import AcademicAnalysis from './academic-analysis.vue';
import TestLine from './test-line.vue';
import dayjs from 'dayjs';
import { getClassEvaluationDetail } from '@/api/pt';
import Empty from '@/views/pt/components/empty.vue';

export default {
  name: 'TestAnalysis',
  components: {
    AcademicAnalysis,
    TestLine,
    Empty,
  },
  props: {
    classId: {
      type: String,
      default: '',
    },
    gradeId: {
      type: String,
      default: '',
    },
    classCreateTime: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      value: '',
      options: [],
      avg_accuary: 0, // 平均正答率
      complete_lv: 0, // 完成率
      evaluation_num: 0, // 测评数
      accuaryTrend: [], // 测评趋势
      start_date: '', // 开始时间
    };
  },
  mounted() {
    this.options = this.getMonth();
    this.getClassEvaluationDetail();
  },
  watch: {
    classId() {
      this.options = this.getMonth();
      this.getClassEvaluationDetail();
    },
  },
  methods: {
    async getClassEvaluationDetail() {
      const params = {
        grade_id: this.gradeId,
        class_id: this.classId,
        start_date: this.start_date,
      };
      const res = await getClassEvaluationDetail(params);
      this.avg_accuary = res.data.avg_accuary;
      this.complete_lv = res.data.complete_lv;
      this.evaluation_num = res.data.evaluation_num;
      this.accuaryTrend = res.data.accuary_trend;
    },
    timeChange(val) {
      this.start_date = val.substring(0, val.length - 1).replace('年', '-');
      this.getClassEvaluationDetail();
    },
    getMonth() { // 获取时间列表
      const beforeMoth = dayjs(this.classCreateTime).add(1, 'month');
      const getmoth = dayjs(new Date()).add(1, 'month');
      this.value = `${getmoth.$y}年${getmoth.$M}月`;
      if (getmoth.$M === 0) {
        this.value = `${getmoth.$y - 1}年${12}月`;
        this.start_date = `${getmoth.$y - 1}-${12}`;
      } else {
        this.start_date = `${getmoth.$y}-${getmoth.$M}`;
      }
      const list = [];
      if (beforeMoth.$y < getmoth.$y) {
        for (let i = beforeMoth.$M; i <= 12; i += 1) {
          list.unshift({
            value: `${getmoth.$y - 1}年${i}月`,
            label: `${getmoth.$y - 1}年${i}月`,
          });
        }
        for (let i = 1; i <= getmoth.$M; i += 1) {
          list.unshift({
            value: `${getmoth.$y}年${i}月`,
            label: `${getmoth.$y}年${i}月`,
          });
        }
      } else if (beforeMoth.$y === getmoth.$y && beforeMoth.$M === 0) {
        list.unshift({
          value: `${beforeMoth.$y - 1}年${12}月`,
          label: `${beforeMoth.$y - 1}年${12}月`,
        });
        for (let i = 1; i <= getmoth.$M; i += 1) {
          list.unshift({
            value: `${getmoth.$y}年${i}月`,
            label: `${getmoth.$y}年${i}月`,
          });
        }
      } else {
        for (let i = beforeMoth.$M; i <= getmoth.$M; i += 1) {
          list.unshift({
            value: `${getmoth.$y}年${i}月`,
            label: `${getmoth.$y}年${i}月`,
          });
        }
      }
      return list;
    },
  },

};
</script>

<style lang="scss" scoped>
.a{
  padding: 41px 60px 0 31px;
  .analysis-overview{
  display: flex;
  justify-content: space-between;
  .analysis-head{
  display: flex;
  align-items: center;
  margin-bottom:11px ;
  &__num{
  font-size: 22px;

  font-weight: bold;
  color: rgba(0, 0, 0, 0.8);
  margin-right: 14px;
  background:url('~@/views/pt/images/class_bg.png');
  background-size:cover;
  width:38px;
  height:29px;
  text-align: center;
  }
  &__title{
  font-size: 17px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.8);
  }
  }
  .p-select{
  position: relative;
  /deep/ {
    .el-icon-date{
      position: absolute;
      z-index: 999;
      top: 12px;
      left: 14px;
    }
  }
  }
  /deep/ {
  .el-select {
    width: 184px;
    height: 40px;
    .el-input__inner{
      padding-left: 35px;
      color: #1890FF;
    }
  }
  }
   }
  .analysis-list{
    margin: 40px 0 40px 0;
    display: flex;
    justify-content: space-between;
    .analysis-item{
      margin-bottom: 32px;
    width: 310px;
    height: 110px;
    background: #F0F2F8;
    border-radius: 12px;
    display: flex;
    padding-left: 21px;
    align-items: center;
    img{
      width: 72px;
      height: 72px;
      margin-right:24px ;
    }
    span{
      font-weight: 500;
      color: #808BAA;
      font-size: 18px;
    }
    .mr-20{
      margin-left: 20px;
      color:#1989FA;
      font-size: 32px;
    }
    .fz-24{
      font-size: 24px;
      margin-left: 10px;

    }
    }
  }
}

</style>
